
import Icon from "../icon";
import Select from "../input/select";

const Search = (props) => {
    const {searchRef, searchColumn, searchColumns, onSearch, handleCloseSearch, onChooseSearchColumn} = props

    const handleKeyDown = (ev) => {
        if (ev.key === 'Enter') {
            onSearch(ev.target.value)
        }
    }

    return (<div className="search-box">
        <div className="search-exit">
            <a href="#" onClick={handleCloseSearch}><Icon name="back"/></a>
        </div>
        <div className="search-input">
            <input type="search" name="search" ref={searchRef} className="search-listing"
                placeholder={`Search by typing the search column and pressing the enter key`}
                onKeyDown={handleKeyDown}
            />
            <Select
                isReady={true}
                value={searchColumn}
                options={searchColumns}
                className="me-3 min-width-200"
                onChange={ev => onChooseSearchColumn(ev)}
            />
        </div>
        <div className="search-action">
            <Icon name="search"/>
        </div>
    </div>)
}

export default Search